/* istanbul ignore file */
import { Typography, Image, Dialog } from '@packages/shared';
import { useState } from 'react';

// TODO(api-layer): remove unnecessary component after resolver implemented
export const LegacyEnergyFlag = ({
  icon,
  overlayTitle = '',
  overlayImg,
}: {
  icon: string;
  overlayTitle?: string;
  overlayImg: string;
}) => {
  const [overlay, setOverlay] = useState(false);

  const overlayContent = (
    <Typography
      component="div"
      sx={{
        position: 'relative',
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 600,
        '> img': {
          objectFit: 'contain',
        },
      }}
    >
      {overlayImg && <Image src={overlayImg} alt={overlayTitle} fill />}
    </Typography>
  );

  return (
    <>
      {overlay && (
        <Dialog
          open={overlay}
          handleClose={() => setOverlay(false)}
          title={overlayTitle}
          dialogContent={overlayContent}
        />
      )}
      <Image
        src={icon}
        width={35}
        height={20}
        alt={overlayTitle}
        onClick={() => setOverlay(true)}
        style={{ cursor: 'pointer' }}
      />
    </>
  );
};
